<template>
  <div class="pop">
    <div class="cover" v-if="showCover"></div>
    <div class="popup" v-if="showCover">
      <div>
        <div class="close" @click="closePop()">
          <img alt="xxx" src="../../../assets/imgs/close-pop.png" style="width: 100%;" />
        </div>
        <div class="img">
          <swiperSec2Pop :imgs="dataPop" :index="index"></swiperSec2Pop>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import swiperSec2Pop from "../../swiper/phev/swiperSec2Pop";
export default {
  props: ["showCover", "popUrl", "dataPop", "closePop"],
  name: "popupMobile",
  components: {
    swiperSec2Pop,
  },
  data() {
    return {
      index: 0,
    };
  },
  created() {},
  mounted() {},
  watch: {
    popUrl: {
      handler(newValue, oldValue) {
        for (let inde in this.dataPop) {
          let item = this.dataPop[inde];
          if (item.url == newValue) {
            this.index = inde;
          }
        }
      },
      deep: true,
    },
  },
  methods: {},
};
</script>
<style scoped>
.cover {
  position: fixed;
  /*首先将位置固定住*/
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  /*上下左右设置都为0*/
  background: rgba(2, 2, 2, 0.7);
  z-index: 10;
}
.popup {
  position: fixed;
  margin: auto;
  left: 0;
  right: 0;
  top: 30%;
  bottom: 0;
  width: 90%;
  z-index: 11;
}
.popup .close {
  position: relative;
  float: right;
  width: 20px;
  cursor: pointer;
}
</style>